<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="gf-search-bar">
    <div class="gf-search-bar__content">
      <input
        v-model="searchModel"
        ref="optionsCreatorInput"
        class="gf-search-bar__input"
        type="text"
        :placeholder="placeholder"
      />
    </div>
    <div class="gf-search-bar__actions">
      <button
        v-if="searchModel?.length > 0"
        type="button"
        class="btn btn-sm text-muted"
        @click="cleanSearch"
      >
        <i class="gf-icon gf-icon-x"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm"
        :disabled="!canSearch"
        @click="submitSearch"
      >
        <i class="gf-icon gf-icon-search"></i>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GfSearchBar',
  props: {
    placeholder: {
      type: String,
      default() {
        return this.$t('message.searchPlaceholder');
      }
    },
    selectedSearch: {
      type: String,
      default: null
    }
  },
  data() {
    return { searchModel: null, lastSearchContent: null };
  },
  computed: {
    canSearch() {
      return (
        this.searchModel !== this.selectedSearch && this.searchModel !== this.lastSearchContent
      );
    }
  },
  mounted() {
    this.searchModel = this.selectedSearch;
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    cleanSearch() {
      this.searchModel = null;
      this.lastSearchContent = null;
      this.submitSearch();
    },
    submitSearch() {
      this.lastSearchContent = this.searchModel;
      this.$emit('submit', this.searchModel);
    },
    onKeydown(e) {
      if (e.key === 'Enter' && this.canSearch) {
        this.submitSearch();
      }
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-search-bar';

#{$this} {
  min-height: 42px;
  padding: 6px 12px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: 8px;
  background-color: var(--light);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);

  @include theme.md {
    min-height: 36px;
  }

  #{$this}__content {
    width: 100%;

    #{$this}__input {
      width: 100%;
      padding: 0;
      color: var(--text);
      background-color: transparent;
      border-style: none;
      outline: none;

      &:placeholder-shown {
        text-overflow: ellipsis;
      }
    }
  }
  #{$this}__actions {
    display: flex;
    gap: 4px;

    & > button {
      min-height: auto;
      padding: 0;

      & > i {
        font-size: 24px;

        @include theme.md {
          font-size: 18px;
        }
      }

      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
